import React, { Component } from 'react';
import Header from '../Common/Component/Header';
import Sidebar from '../Common/Component/Sidebar';
class Demo extends Component {
  render() {
    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header />

          {/* Sidebar */}
          <Sidebar history={this.props.history} />


          <div className="container">

            <div className="">
              <h1>Hello world</h1>
            </div>

          </div>
        </div>
      </div>
    );
  }
}

export default Demo;